import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog, DialogContent, DialogFooter, DialogTitle,
} from '../../../components/base/Dialog/Dialog';
import { Button, Icons, Row } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../components/fields/TextInput/TextInputWithLabel';
import ApplicationsDialogDTO from '../../../dto/ApplicationsDialogDTO';
import { loadReasonListAll } from '../../ReferenceInformation/actions';
import { responseLogWithNotification } from '../../../utils/utils';
import { getReferenceInformationData } from '../../ReferenceInformation/reducer';
import { REASON_TYPE, REGISTRIES_TYPE } from '../../../configs';
import CustomSelectInputWithHelper from '../../../components/fields/SelectInput/CustomSelectInputWithHelper';
import CheckBoxInputWithLabel from '../../../components/fields/CheckBoxInput/CheckBoxInputWithLabel';
import { showGlobalConfirm } from '../../System/actions';
import { infoFormatterIntl, renderRegistryValidationMessage } from '../../../utils/formatters';
import { loadCarrierFieldsValidation, loadSZLTFieldsValidation, loadVehicleFieldsValidation } from '../actions';
import TimerLoader from '../../../components/base/Loader/TimerLoader';

export default function ResumedReasonDialog(props) {
  const {
    close = () => {},
    send = () => {},
    legal_entity_type = '',
    typeRegistry = 0,
    current,
    withoutValidation = false,
  } = props;
  const onSend = () => {
    const values = getValues();
    send(values);
  };
  const {
    control, getValues, setValue, watch,
  } = useForm({ defaultValues: {} });
  const DTO = new ApplicationsDialogDTO();
  const attributes = DTO.getAttributesByName();
  const {
    loadingReasonList,
    reasonListAll,
  } = useSelector(getReferenceInformationData);
  const dispatch = useDispatch();
  const [rejectionReason, setRejectionReason] = useState([]);
  const [selected, setSelected] = React.useState([]);

  const validationMap = {
    [REGISTRIES_TYPE.VEHICLE]: loadVehicleFieldsValidation,
    [REGISTRIES_TYPE.CARRIER]: loadCarrierFieldsValidation,
    [REGISTRIES_TYPE.ORDER_SERVICE]: loadSZLTFieldsValidation,
  };

  const action = validationMap[typeRegistry] || loadSZLTFieldsValidation;

  const handleValidateAndAccept = () => {
    if (withoutValidation) {
      onSend();
      return;
    }
    dispatch(action({ id: current?.id })).then(data => {
      const checkErrors = data?.checks || {};
      const errors = data?.errors || {};
      const checkErrorsKeys = Object.keys(checkErrors);
      const errorsKeys = Object.keys(errors);
      if (Object.values(checkErrors).filter(f => f.status !== 2).length + errorsKeys.length) {
        dispatch(showGlobalConfirm({
          confirmTitle: 'Реестровая запись содержит ошибки в полях',
          confirmMessage: renderRegistryValidationMessage(errors, checkErrors, checkErrorsKeys, errorsKeys),
          confirmButtonText: 'Вернуть',
          confirmClassName: 'remove-preset',
        })).then(() => {
          onSend();
        }).catch(() => {});
      } else {
        onSend();
      }
    }).catch(responseLogWithNotification);
  };

  useEffect(() => {
    const subscription = watch(values => {
      if (values && values?.rejection_reason_id) {
        setRejectionReason(values.rejection_reason_id);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    const currentRejectionReason = reasonListAll.find(e => rejectionReason === e.id);
    if (currentRejectionReason) {
      setValue('rejection_reason_note', currentRejectionReason?.message);
      setSelected([{ name: currentRejectionReason?.name, value: currentRejectionReason?.id }]);
    } else {
      setSelected([]);
    }
  }, [rejectionReason]);

  return (
    <Dialog
      className="application-denied-dialog"
      onClose={close}
      open
    >
      <DialogTitle header="Возобновление реестровой записи" title={<Icons onClick={close} customIcon icon="close" className="close" />} />
      <DialogContent className="application-denied-content">
        <TimerLoader loading={loadingReasonList} />
        <Row>
          <FieldDTOWithCol
            control={control}
            component={CustomSelectInputWithHelper}
            dtoObject={attributes.rejection_reason_id}
            variant="material"
            withLabel
            optionFormatter={item => ({ value: item.id, name: item.name })}
            loadAction={loadReasonListAll}
            additionalFilter={{ reasons_type: REASON_TYPE.REGISTRY_RESUMED, legal_entity_types: [legal_entity_type] }}
            customRenderOptions={(item, key, isSelected) => (
              <CheckBoxInputWithLabel
                inputProps={{ value: isSelected, onChange: false }}
                label={item?.name || ''}
                key={key}
              />
            )}
            defaultOptions={selected}
          />
        </Row>
        <Row>
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.rejection_reason_note}
            variant="material"
            inputClassName="custom-scroll-theme"
            withLabel
            textarea
            disabled
          />
        </Row>
        <Row>
          <FieldDTOWithCol
            control={control}
            component={TextInputWithLabel}
            dtoObject={attributes.additional_rejection_reason}
            variant="material"
            textarea
            withLabel
          />
        </Row>
      </DialogContent>
      <DialogFooter className="hff-footer">
        <div className="hff-footer-buttons">
          <Button className="hff-clear-data" variant="secondary" onClick={close}>Отменить</Button>
          <Button className="hff-clear-show" onClick={handleValidateAndAccept}>Возобновить</Button>
        </div>
      </DialogFooter>
    </Dialog>
  );
}
